import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTheme } from 'styled-components';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store';
import { shouldEnableNewFlowSelector } from 'ggApp/modules/featureFlag';

import { PaymentSdkContext } from './state/paymentSdkContext';
import GatewaySelectorUi from './GatewaySelectorUi';

const mapStateToProps = createStructuredSelector({
    activeStore: activeStoreSelector,
    withNewFlowCard: shouldEnableNewFlowSelector,
});

const GatewaySelector = ({
    onPaymentMethodCreated,
    onLegacyPaymentMethodCreated,
    activeStore,
    children,
    theme,
    uiComponent,
    withNewFlowCard,
    orderNumber,
    paymentTermsInfo,
    setPaymentTermsInfo,
}) => {
    const sdkInstance = useContext(PaymentSdkContext);
    const [isPaymentGatewaysLoading, setPaymentGatewaysLoadingState] = useState(false);
    const [paymentGateways, setPaymentGateways] = useState(null);

    useEffect(() => {
        setPaymentGatewaysLoadingState(true);
        sdkInstance
            .getPaymentGateways(activeStore.code)
            .then(({ data }) => {
                const gatewayList = data.payment_gateways;
                setPaymentGateways(gatewayList);
            })
            .finally(() => setPaymentGatewaysLoadingState(false));
    }, [sdkInstance, activeStore]);

    const isDarkMode = theme.mode === 'dark';

    const UiComponent = uiComponent || GatewaySelectorUi;
    return (
        <UiComponent
            orderNumber={orderNumber}
            isPaymentGatewaysLoading={isPaymentGatewaysLoading}
            isDarkMode={isDarkMode}
            paymentGateways={paymentGateways}
            onPaymentMethodCreated={onPaymentMethodCreated}
            onLegacyPaymentMethodCreated={onLegacyPaymentMethodCreated}
            withNewFlowCard={withNewFlowCard}
            paymentTermsInfo={paymentTermsInfo}
            setPaymentTermsInfo={setPaymentTermsInfo}
        >
            {children}
        </UiComponent>
    );
};

GatewaySelector.propTypes = {
    onPaymentMethodCreated: PropTypes.func.isRequired,
    activeStore: PropTypes.shape({
        code: PropTypes.string,
    }).isRequired,
    user: PropTypes.shape({
        id: PropTypes.number,
    }).isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    theme: PropTypes.shape({
        mode: PropTypes.string,
    }).isRequired,
};

GatewaySelector.defaultProps = {
    children: null,
};

export default connect(mapStateToProps)(withTheme(GatewaySelector));
